<template>
  <v-row class="user-view" justify="center">
    <v-col cols="12" md="9" lg="8">
      <div v-if="loading" class="text-center" py-5>
        <h3>Loading Your Account</h3>
        <v-progress-circular indeterminate class="mt-5" />
      </div>
      <v-card
        v-else-if="error"
        class="mt-5 pa-3 mx-auto text-center"
        style="max-width:500px"
        outlined
        flat
      >
        <v-card-text>
          <h2 class="text-h4 font-weight-bold">Something went wrong.</h2>
          <div>{{ error }}</div>
        </v-card-text>
      </v-card>
      <template v-else>
        <v-sheet class="mb-5" flat>
          <v-row dense>
            <v-col cols="12">
              <h2 class="text-h4 font-weight-bold mb-2">Order History</h2>
              <h3>Click an Order to View Details</h3>
            </v-col>
            <v-col cols="auto">
              <v-btn
                color="deep-orange"
                class="white--text"
                depressed
                :to="{
                  name: newOrderRoute,
                  params: $route.params,
                }"
                >Start a New Order</v-btn
              >
            </v-col>
            <v-col cols="auto">
              <v-btn
                depressed
                class="white--text"
                color="blue"
                :to="{ name: editAccountRoute }"
                >Account Settings</v-btn
              >
            </v-col>
          </v-row>
        </v-sheet>
        <CustomerOrders :orders="orders" />
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { CustomerRoutes, GuestRoutes } from '@/constants/RouteNames'
import { mapGetters, mapActions } from 'vuex'
import CustomerOrders from '@/components/CustomerOrders'
import OrderModel from '@/models/OrderModel'

export default {
  name: 'OrderHistoryView',
  components: { CustomerOrders },
  data() {
    return {
      loading: true,
      error: null,
      newOrderRoute: GuestRoutes.NEW_ORDER,
      editAccountRoute: CustomerRoutes.ACCOUNT_UPDATE,
    }
  },
  computed: {
    ...mapGetters('auth', ['getAuthUser']),
    orders() {
      return OrderModel.query('user_id', this.getAuthUser.id).get()
    }, // orders
  },
  methods: {
    ...mapActions('customer', ['fetchOrders']),
  },
  async created() {
    this.error = null
    this.loading = true
    try {
      await this.fetchOrders()
    } catch (error) {
      this.error =
        'We were unable to load your order history. Please try again.'
    } finally {
      this.loading = false
    }
  },
}
</script>

<style lang="css">
.order-row {
  cursor: pointer;
}
.center-checkbox .v-input__slot {
  justify-content: center !important;
}
.center-checkbox .v-input__slot .v-input--selection-controls__input {
  margin-right: 0;
}
</style>
